





























import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

import MobileEventQueueItem from "./MobileEventQueueItem.vue";
import { AlarmQueueFilterID, FilteredEvent } from "@/store/eventqueue/types";

import EventTypes from "@/types/EventTypes";

const Eventqueue = namespace("eventqueue");

@Component({
	components: {
		"mobile-event-queue-item": MobileEventQueueItem
	}
})
export default class MobileEventQueueList extends Vue  {

	@Eventqueue.Getter("getActiveFilterID") activeFilterID!: AlarmQueueFilterID;

    @Eventqueue.Getter("getFilteredEvents") getFilteredEvents!: FilteredEvent[];

    @Eventqueue.Action fetchEventQueue: (filters?: AlarmQueueFilterID[]) => Promise<void>;

	public updateInterval: NodeJS.Timeout;
	public stopped: boolean = false;

	@Watch("activeFilterID")
	public async updatedFilters() {
		await this.fetchEventQueue()
	}


	private alarmQueueEvents() : FilteredEvent[] {

		let alarmQueueEvents = this.getFilteredEvents.filter(
			q =>
				q.eventTypeID == EventTypes.Alarm && 
				q.inProcessing == false &&
				q.unParkAt == null &&
				q.isPermanentParked == false &&
				q.readyForPostProcessing == null &&
				q.groupID
		);

		return alarmQueueEvents;
	}

	public async mounted() {

		this.stopped = false;

		await this.fetchEventQueue()

		this.updateInterval = setTimeout(this.update, 10000);
	}

	public async update() {
		if (!this.stopped) {
			const before = performance.now();

			try {
				await this.fetchEventQueue();
			} catch (ex) {
				console.error(ex);
			}

			const after = performance.now();
			const timeTaken = after - before;

			// the longer it takes, the shorter the next update, down to 10ms
			this.updateInterval = setTimeout(this.update, Math.max(10, 10000 - timeTaken)); 
		} else {
			if (this.updateInterval != null) {
				clearTimeout(this.updateInterval);
				this.updateInterval = null;
			}
		}
	}

	public destroyed() {
		this.stopped = true;
		if (this.updateInterval != null) {
			clearInterval(this.updateInterval);
			this.updateInterval = null;
		}
	}
}
